import { render } from "./OrdersCard.vue?vue&type=template&id=0e5854ae&scoped=true"
import script from "./OrdersCard.vue?vue&type=script&lang=js"
export * from "./OrdersCard.vue?vue&type=script&lang=js"

import "./OrdersCard.vue?vue&type=style&index=0&id=0e5854ae&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e5854ae"]])

export default __exports__